// extracted by mini-css-extract-plugin
export default {"ourTeamWrapper":"ourTeam_ourTeamWrapper__4zXwe","cardParent":"ourTeam_cardParent__uuIGH","name":"ourTeam_name__vroxw","avatar":"ourTeam_avatar__r9Ew9","case":"ourTeam_case__XTGb9"};